module.exports = {"530723101":"中心镇","530723102":"荣将镇","530723103":"兴泉镇","530723104":"石龙坝镇","530723202":"新庄傈僳族傣族乡","530723203":"通达傈僳族乡","530723204":"永兴傈僳族乡","530723205":"船房傈僳族傣族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530723.json
// module id = 2403
// module chunks = 0